(function () {
  if (window.__cartCollectionPromotionsInit) return;
  window.__cartCollectionPromotionsInit = true;
  var DB = 48,
    U = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart.js',
    P = 'ccpromo:v2:',
    IC = '<svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14" aria-hidden="true"><path d="M12 2l1.2 4.2L17 8l-4.2 1.2L12 13l-1.2-4.8L7 8l4.2-1.8L12 2zM5 14l.8 2.8L8.5 18l-2.7.7L5 21.5l-.8-2.8L1.5 18l2.7-.7L5 14zm14 1l.6 2.1L21.5 18l-2.1.5L19 21l-.6-2.1L16.5 18l2.1-.5L19 15z" opacity=".9"/></svg>',
    IK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>',
    cache = new Map(),
    nfCache = new Map(),
    tmr,
    sig = '',
    op = 0;

  function deb(fn) {
    clearTimeout(tmr);
    tmr = setTimeout(fn, DB);
  }
  function ss(h) {
    try {
      var r = sessionStorage.getItem(P + h);
      if (!r) return null;
      var a = JSON.parse(r);
      return Array.isArray(a) ? new Set(a) : null;
    } catch (e) {
      return null;
    }
  }
  function sv(h, s) {
    try {
      sessionStorage.setItem(P + h, JSON.stringify(Array.from(s)));
    } catch (e) {}
  }
  function qCfg(r) {
    var e = r.querySelector('.cart-promotions-config');
    if (!e) return [];
    try {
      var d = JSON.parse(e.textContent || '[]');
      return Array.isArray(d) ? d : [];
    } catch (e) {
      return [];
    }
  }
  function qMem(r) {
    var e = r.querySelector('.cart-promotions-membership'),
      m = new Map();
    if (!e) return m;
    try {
      var o = JSON.parse(e.textContent || '{}');
      if (o && typeof o === 'object')
        for (var k in o) {
          var a = o[k];
          m.set(k, new Set(Array.isArray(a) ? a.map(Number) : []));
        }
    } catch (e) {}
    return m;
  }
  function qMsg(r) {
    return r.querySelector('[data-cart-promotions-messages]');
  }
  function merge(h, L) {
    var o = new Set(),
      a = cache.get(h),
      l = L.get(h);
    if (a) a.forEach(function (id) { o.add(id); });
    if (l) l.forEach(function (id) { o.add(id); });
    return o;
  }
  function grp(f) {
    var m = new Map(),
      i,
      g,
      row;
    for (i = 0; i < f.length; i++) {
      row = f[i];
      if (!row || !row.handle) continue;
      g = m.get(row.handle);
      if (!g) {
        g = { rules: [], successMessage: '', title: '' };
        m.set(row.handle, g);
      }
      g.rules.push(row);
      var sm = row.success_message && String(row.success_message).trim();
      if (sm && !g.successMessage) g.successMessage = sm;
      var ct = row.title && String(row.title).trim();
      if (ct && !g.title) g.title = ct;
    }
    m.forEach(function (g) {
      g.rules.sort(function (a, b) { return a.threshold_minor - b.threshold_minor; });
    });
    return m;
  }
  function title(g, h) {
    if (g.title && String(g.title).trim()) return g.title.trim();
    return String(h || '')
      .split('-')
      .filter(Boolean)
      .map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); })
      .join(' ');
  }
  function money(minor, cur) {
    var m = Math.round(Number(minor)),
      w = Math.trunc(m / 100),
      s = ((m % 100) + 100) % 100;
    if (s > 50) w++;
    cur = cur || 'USD';
    var lang = document.documentElement.lang || '',
      key = lang + '\0' + cur,
      nf = nfCache.get(key);
    if (!nf) {
      try {
        nf = new Intl.NumberFormat(lang || undefined, { style: 'currency', currency: cur, minimumFractionDigits: 0, maximumFractionDigits: 0 });
        nfCache.set(key, nf);
      } catch (e) {
        return String(w);
      }
    }
    try {
      return nf.format(w);
    } catch (e) {
      return String(w);
    }
  }
  function disc(rule, cur) {
    if (rule.discount_type === 'percentage') return rule.discount_value + '%';
    return money(Math.round(Number(rule.discount_value) * 100), cur);
  }
  function cart() {
    return fetch(U, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw 0;
      return r.json();
    });
  }
  function pages(h) {
    return (function loop(pg, ids) {
      return fetch('/collections/' + encodeURIComponent(h) + '/products.json?limit=250&page=' + pg)
        .then(function (r) {
          if (!r.ok) return ids;
          return r.json().then(function (d) {
            var pr = d.products || [],
              i;
            for (i = 0; i < pr.length; i++) ids.add(pr[i].id);
            if (pr.length < 250) return ids;
            return loop(pg + 1, ids);
          });
        })
        .catch(function () { return ids; });
    })(1, new Set());
  }
  function fetchIds(h) {
    if (cache.has(h)) return Promise.resolve(cache.get(h));
    var d = ss(h);
    if (d && d.size) {
      cache.set(h, d);
      fetchIds.refresh(h).catch(function () {});
      return Promise.resolve(d);
    }
    return pages(h).then(function (ids) {
      cache.set(h, ids);
      sv(h, ids);
      return ids;
    });
  }
  fetchIds.refresh = function (h) {
    return pages(h).then(function (ids) {
      cache.set(h, ids);
      sv(h, ids);
      return ids;
    });
  };
  function ensure(H) {
    return Promise.all(H.map(fetchIds));
  }
  function prefetch(H) {
    if (!H || !H.length) return;
    H.forEach(function (h) {
      if (!cache.has(h)) {
        var d = ss(h);
        if (d && d.size) cache.set(h, d);
      }
      fetchIds(h).catch(function () {});
    });
  }
  function subtot(cart, set) {
    var s = 0,
      it,
      i;
    if (!cart || !cart.items || !cart.items.length || !set) return 0;
    for (i = 0; i < cart.items.length; i++) {
      it = cart.items[i];
      if (set.has(it.product_id)) s += it.final_line_price;
    }
    return s;
  }
  function nextRule(rules, st) {
    var i;
    for (i = 0; i < rules.length; i++) if (st < rules[i].threshold_minor) return rules[i];
    return null;
  }
  function hiTh(rules) {
    var m = 0,
      i;
    for (i = 0; i < rules.length; i++) if (rules[i].threshold_minor > m) m = rules[i].threshold_minor;
    return m;
  }
  function tpl(t, o) {
    return String(t)
      .replace(/\{collection\}/g, o.collection)
      .replace(/\{remaining\}/g, o.remaining)
      .replace(/\{discount\}/g, o.discount);
  }
  function cSig(cart, gm, L) {
    var parts = [],
      h,
      g,
      set,
      sub,
      keys,
      i,
      it;
    gm.forEach(function (g, handle) {
      set = merge(handle, L);
      if (!set.size) return;
      sub = 0;
      keys = [];
      for (i = 0; i < (cart.items || []).length; i++) {
        it = cart.items[i];
        if (!set.has(it.product_id)) continue;
        sub += it.final_line_price;
        keys.push(it.key + ':' + it.final_line_price);
      }
      keys.sort();
      parts.push(handle + '|' + sub + '|' + keys.join(','));
    });
    return parts.join(';;');
  }
  function shell() {
    var st = document.createElement('div');
    st.className = 'cart-promo-stack';
    st.dataset.cartPromoStack = '';
    var hd = document.createElement('div');
    hd.className = 'cart-promo-stack__header';
    var ic = document.createElement('span');
    ic.className = 'cart-promo-stack__icon';
    ic.setAttribute('aria-hidden', 'true');
    ic.innerHTML = IC;
    var ey = document.createElement('span');
    ey.className = 'cart-promo-stack__eyebrow';
    ey.textContent = 'Exclusive offer: Coupon Available at Checkout ';
    hd.append(ic, ey);
    var ul = document.createElement('ul');
    ul.className = 'cart-promo-stack__list';
    ul.setAttribute('role', 'list');
    st.append(hd, ul);
    return { stack: st, ul: ul };
  }
  function row(handle, colTitle, state, msg, pct) {
    var li = document.createElement('li');
    li.className = 'cart-promo-row' + (state === 'success' ? ' cart-promo-row--success' : '');
    li.dataset.collection = handle;
    li.dataset.state = state;
    var top = document.createElement('div');
    top.className = 'cart-promo-row__top';
    if (state === 'success') {
      var mk = document.createElement('span');
      mk.className = 'cart-promo-row__mark';
      mk.setAttribute('aria-hidden', 'true');
      mk.innerHTML = IK;
      top.appendChild(mk);
    }
    if (colTitle) {
      var nm = document.createElement('span');
      nm.className = 'cart-promo-row__name font-family__clash-display-semibold';
      nm.textContent = colTitle;
      var sp = document.createElement('span');
      sp.className = 'cart-promo-row__sep';
      sp.setAttribute('aria-hidden', 'true');
      sp.textContent = '\u00b7';
      top.append(nm, sp);
    }
    var tx = document.createElement('span');
    tx.className = 'cart-promo-row__text';
    tx.textContent = msg;
    top.appendChild(tx);
    if (state === 'goal' && typeof pct === 'number' && !isNaN(pct)) {
      var p = Math.min(100, Math.max(0, Math.round(pct))),
        pe = document.createElement('span');
      pe.className = 'cart-promo-row__pct';
      pe.textContent = p + '%';
      top.appendChild(pe);
      var br = document.createElement('div');
      br.className = 'cart-promo-row__bar';
      br.setAttribute('role', 'progressbar');
      br.setAttribute('aria-valuemin', '0');
      br.setAttribute('aria-valuemax', '100');
      br.setAttribute('aria-valuenow', String(p));
      var fl = document.createElement('span');
      fl.className = 'cart-promo-row__bar-fill';
      fl.style.width = p + '%';
      br.appendChild(fl);
      li.append(top, br);
    } else li.appendChild(top);
    return li;
  }
  function ui(root, cart, gm, L) {
    if (cart.currency) root.dataset.currency = cart.currency;
    var cur = root.dataset.currency || cart.currency || 'USD',
      host = qMsg(root);
    if (!host) return;
    if (!cart || !cart.items || !cart.items.length) {
      host.replaceChildren();
      root.hidden = true;
      return;
    }
    var rows = [],
      h,
      g,
      rules,
      set,
      st,
      has,
      ct,
      nx,
      hi,
      rem,
      dc,
      ms,
      pc;
    gm.forEach(function (g, handle) {
      rules = g.rules;
      set = merge(handle, L);
      if (!set.size) return;
      st = subtot(cart, set);
      has = false;
      for (var i = 0; i < cart.items.length; i++) {
        if (set.has(cart.items[i].product_id)) {
          has = true;
          break;
        }
      }
      if (!has) return;
      ct = title(g, handle);
      nx = nextRule(rules, st);
      hi = hiTh(rules);
      if (nx) {
        rem = money(Math.max(0, nx.threshold_minor - st), cur);
        dc = disc(nx, cur);
        ms = tpl(nx.message, { remaining: rem, discount: dc, collection: ct });
        pc = nx.threshold_minor > 0 ? (st / nx.threshold_minor) * 100 : 0;
        rows.push(row(handle, ct, 'goal', ms, pc));
      } else if (g.successMessage && hi > 0 && st >= hi) {
        ms = tpl(g.successMessage, { remaining: '', discount: '', collection: ct });
        rows.push(row(handle, ct, 'success', ms, null));
      }
    });
    if (!rows.length) {
      host.replaceChildren();
      root.hidden = true;
      return;
    }
    var sh = shell();
    rows.forEach(function (li) { sh.ul.appendChild(li); });
    host.replaceChildren(sh.stack);
    root.hidden = false;
  }
  function run(root) {
    var id = ++op,
      flat = qCfg(root),
      gm = grp(flat),
      L = qMem(root);
    if (!gm.size) {
      var h = qMsg(root);
      if (h) h.replaceChildren();
      root.hidden = true;
      return;
    }
    cart().then(function (c) {
      if (id !== op) return;
      var H = Array.from(gm.keys());
      return ensure(H).then(function () {
        if (id !== op) return;
        var s = cSig(c, gm, L);
        if (s === sig) return;
        sig = s;
        if (id !== op) return;
        ui(root, c, gm, L);
      });
    }).catch(function () {});
  }
  function root() {
    return document.querySelector('[data-cart-promotions]');
  }
  function now() {
    clearTimeout(tmr);
    var r = root();
    if (r) run(r);
    else sig = '';
  }
  function later() {
    deb(function () {
      var r = root();
      if (r) run(r);
      else sig = '';
    });
  }
  function handles() {
    var r = root();
    if (!r) return [];
    return Array.from(grp(qCfg(r)).keys());
  }
  function wire() {
    prefetch(handles());
    (window.requestIdleCallback || function (f) { setTimeout(f, 1); })(function () { prefetch(handles()); });
    var sel = 'modal-trigger[target="#cart-modal"], [data-open-cart], a[href*="/cart"]';
    document.addEventListener(
      'pointerenter',
      function (e) {
        if (e.target.closest(sel)) prefetch(handles());
      },
      { capture: true, passive: true }
    );
    var cm = document.getElementById('cart-modal');
    if (cm) {
      var os = function () {
        prefetch(handles());
        now();
      };
      cm.addEventListener('show', os);
      cm.addEventListener('show-end', os);
    }
  }
  function init() {
    wire();
    document.addEventListener('product:added-to-cart', now);
    var m = document.querySelector('cart-modal');
    if (m) new MutationObserver(later).observe(m, { childList: true, subtree: true });
    now();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
